"use strict";

var _regeneratorRuntime = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureRoot = exports.DEFAULT_APPLICATION_OPTIONS = void 0;

var Scriptable_1 = require("../Scriptable");

var feature_1 = require("../log/feature");

var FeatureHookManager_1 = require("./FeatureHookManager");

var FeatureResourceManager_1 = require("./FeatureResourceManager");

var FeatureServicesManager_1 = require("./FeatureServicesManager");
/**
 * The default application options for a Feature application.
 */


exports.DEFAULT_APPLICATION_OPTIONS = {
  name: 'feature',
  frontend: 'https://feature.com',
  domain: 'feature.com',
  rootDomain: 'feature.com',
  services: {}
};
/**
 * The most basic root implementation for a Feature application.
 *
 * @remarks
 * This is the main class for managing a Feature-based application. It has helper methods
 * for using and configuring features, and preparing and running the service.
 *
 * There are three prepare methods, early, middle, and late, and they each call their corresponding
 * method on each of the used features. This is to allow features to create resources, hooks, or
 * perform other actions based on what resources, hooks, etc other features in the system add when
 * they're constructed.
 *
 * We split preparation into 3 phases to account for one feature needing to prepare after another
 * feature. Because of this, it is essential you not use {@link FeatureRoot.prepareLate} unless you
 * <i>absolutely need to.</i>
 */

var FeatureRoot = /*#__PURE__*/function () {
  function FeatureRoot(appOptions, deps) {
    _classCallCheck(this, FeatureRoot);

    this.features = {};
    this.appOptions = appOptions;
    var hookManager = new FeatureHookManager_1.FeatureHookManager();
    var resources = new FeatureResourceManager_1.FeatureResourceManager();
    var services = new FeatureServicesManager_1.FeatureServicesManager(Object.assign(Object.assign({}, appOptions.services), {
      root: this
    })); // @ts-ignore fix the deps optional requirement above

    this.deps = Object.assign({
      hookManager: hookManager,
      resources: resources,
      services: services,
      root: this
    }, deps);
  }
  /**
   * Use a feature.
   * @remarks
   * Also means, "add a feature to the project."
   * @param Feature - the feature to add
   * @param options - the options to use for that feature
   */


  _createClass(FeatureRoot, [{
    key: "useFeature",
    value: function useFeature(Feature, options) {
      (0, feature_1.debug)('using feature: %s', Feature.package);

      if (this.features[Feature.package]) {
        throw new Error("Attempting to use feature '".concat(Feature.package, "' multiple times."));
      }

      this.features[Feature.package] = new Feature(options, this.deps);
    }
    /**
     * Use multiple features at once.
     * @param features - an array of feature use definitions representing features to use
     */

  }, {
    key: "use",
    value: function use(features) {
      var _iterator = _createForOfIteratorHelper(features),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var feature = _step.value;

          if (Array.isArray(feature)) {
            this.useFeature(feature[0], feature[1]);
          } else {
            this.useFeature(feature, {});
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Gets a feature by its package name.
     * @param name - the package name of the feature to get
     * @returns the feature if found, otherwise undefined
     */

  }, {
    key: "getFeature",
    value: function getFeature(name) {
      return this.features[name] ? this.features[name] : undefined;
    }
    /**
     * {@link FeatureRoot.getFeature | getFeature,} but throws an error if the feature isn't found.
     * @param name - the package name of the feature to get
     * @returns the feature
     */

  }, {
    key: "requireFeature",
    value: function requireFeature(name) {
      var result = this.getFeature(name);

      if (!result) {
        throw new Error("Feature '".concat(name, "' could not be found."));
      }

      return result;
    }
  }, {
    key: "runLifecycle",
    value: function runLifecycle(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, feature_1.debug)('running lifecycle: %s', key);
                _context.next = 3;
                return Promise.all(Object.keys(this.features).map(function (featureName) {
                  var feature = _this.features[featureName];
                  var callback = feature[key];

                  if (callback) {
                    (0, feature_1.debug)('...in %s', featureName);
                    return callback.call(feature);
                  }
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Runs early preparations.
     */

  }, {
    key: "prepareEarly",
    value: function prepareEarly() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.runLifecycle('prepareEarly'));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Runs middle preparations.
     */

  }, {
    key: "prepareMiddle",
    value: function prepareMiddle() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.runLifecycle('prepareMiddle'));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Runs late preparations.
     */

  }, {
    key: "prepareLate",
    value: function prepareLate() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.runLifecycle('prepareLate'));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Runs all three preparation phases, if not already prepared.
     * @remarks
     * This function has internal checks to make sure we only prepare a Feature root once,
     * as preparing it multiple times would result in duplicate resources being added.
     */

  }, {
    key: "prepare",
    value: function prepare() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.preparePromise) {
                  _context5.next = 5;
                  break;
                }

                (0, feature_1.debug)('Already preparing / prepared. Returning promise.');
                return _context5.abrupt("return", this.preparePromise);

              case 5:
                this.preparePromise = this.prepareEarly().then(function () {
                  return _this2.prepareMiddle();
                }).then(function () {
                  return _this2.prepareLate();
                });
                return _context5.abrupt("return", this.preparePromise);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
    /** Runs all three beforeDeploy phases. */

  }, {
    key: "beforeDeploy",
    value: function beforeDeploy() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.runLifecycle('beforeDeployEarly');

              case 2:
                _context6.next = 4;
                return this.runLifecycle('beforeDeployMiddle');

              case 4:
                _context6.next = 6;
                return this.runLifecycle('beforeDeployLate');

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
    /** Runs all three afterDeploy phases. */

  }, {
    key: "afterDeploy",
    value: function afterDeploy() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.runLifecycle('afterDeployEarly');

              case 2:
                _context7.next = 4;
                return this.runLifecycle('afterDeployMiddle');

              case 4:
                _context7.next = 6;
                return this.runLifecycle('afterDeployLate');

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
    /**
     * Allows other features to add commands and options to the Feature command line.
     * @remarks
     * See the documentation for the feature-scripts feature for more information.
     * @param argv - the yargs instance to configure
     * @returns a promise with the configured yargs instance
     */

  }, {
    key: "bootstrapScripts",
    value: function bootstrapScripts(argv) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.prepare();

              case 2:
                return _context8.abrupt("return", this.deps.hookManager.mutateHook(Scriptable_1.CLI_HOOK, argv, undefined));

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }]);

  return FeatureRoot;
}();

exports.FeatureRoot = FeatureRoot;